import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap, tap } from 'rxjs/operators';
import { UserId } from '@business/entities/account';
import { BattlePlanSectionTaskResponse, SectionId, TaskId } from '@business/entities/battle_plan';
import { BattlePlanSectionTaskAPI } from '@business/api/battle_plan_section_task';
import { of } from 'rxjs';

export class BattlePlanSectionTaskBloc extends BaseBloc {
  private readonly battlePlanSectionTasksRepo = new Repository<BattlePlanSectionTaskResponse>({
    getItemId: item => item.id,
  });

  readonly allBattlePlanSectionTasks$ = this.battlePlanSectionTasksRepo.items$;
  readonly selectBattlePlanSectionTask = this.battlePlanSectionTasksRepo.selectItem;

  readonly completedNoSectionTasks$ = this.battlePlanSectionTasksRepo.items$.pipe(map(tasks => tasks.filter(u => u.isTaskCompleted)));
  readonly notCompletedNoSectionTasks$ = this.battlePlanSectionTasksRepo.items$.pipe(map(tasks => tasks.filter(u => !u.isTaskCompleted)));

  onReset() {
    this.battlePlanSectionTasksRepo.reset();
  }

  fetchBattlePlanTasks = () => {
    return BattlePlanSectionTaskAPI.fetchBattlePlanTasks().pipe(
      this.battlePlanSectionTasksRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_battle_plan_task_error') }),
    );
  };

  fetchBattlePlanTask = (taskId: TaskId) => {
    return BattlePlanSectionTaskAPI.fetchBattlePlanTask(taskId).pipe(
      this.battlePlanSectionTasksRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_battle_plan_task_error') }),
    );
  };

  updateTask = (id: TaskId, data: Partial<BattlePlanSectionTaskResponse>) => {
    return BattlePlanSectionTaskAPI.updateBattlePlanTasks(id, data).pipe(
      this.battlePlanSectionTasksRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_battle_plan_task'),
      }),
    );
  };
}
